const REWARD_IMAGE_API_PREFIX = '/api/rewards/images/';

const REWARD_IMAGES_BY_NAME = {
  'Bronze Gift Card': `${REWARD_IMAGE_API_PREFIX}royal-prestige-santoku-knife-5.jpg`,
  'Silver Gift Card': `${REWARD_IMAGE_API_PREFIX}royal-prestige-bamboo-cutting-board.jpg`,
  'Gold Gift Card': `${REWARD_IMAGE_API_PREFIX}royal-prestige-mixing-bowls-2-piece.webp`,
  'Royal Prestige® Santoku Knife 5"': `${REWARD_IMAGE_API_PREFIX}royal-prestige-santoku-knife-5.jpg`,
  'Royal Prestige® Bamboo Cutting Board': `${REWARD_IMAGE_API_PREFIX}royal-prestige-bamboo-cutting-board.jpg`,
  'Royal Prestige® 2-Piece Mixing Bowls Set': `${REWARD_IMAGE_API_PREFIX}royal-prestige-mixing-bowls-2-piece.webp`,
  'Royal Prestige® Knife Sharpener': `${REWARD_IMAGE_API_PREFIX}royal-prestige-knife-sharpener.jpg`,
  'Royal Prestige® Pasta Strainer': `${REWARD_IMAGE_API_PREFIX}royal-prestige-pasta-strainer.jpg`,
  'Royal Prestige® Kitchen Utensils Set': `${REWARD_IMAGE_API_PREFIX}royal-prestige-utensils-set.jpg`,
  'Royal Prestige® London Short Glasses': `${REWARD_IMAGE_API_PREFIX}royal-prestige-london-glasses.jpg`,
  'Royal Prestige® ExperTea': `${REWARD_IMAGE_API_PREFIX}royal-prestige-expertea.jpg`,
  'Royal Prestige® Chocolatera': `${REWARD_IMAGE_API_PREFIX}royal-prestige-chocolatera.jpg`,
  'Royal Prestige® Smart Temp': `${REWARD_IMAGE_API_PREFIX}royal-prestige-smart-temp.webp`,
  'Royal Prestige® Warmer Pro': `${REWARD_IMAGE_API_PREFIX}royal-prestige-warmer-pro.webp`,
  'Royal Prestige® Utility Knife': `${REWARD_IMAGE_API_PREFIX}royal-prestige-utility-knife.jpg`,
  'Royal Prestige® Food Storage Set': `${REWARD_IMAGE_API_PREFIX}royal-prestige-storage-containers.jpg`,
  '10% Off Elevate Hispanos Event': `${REWARD_IMAGE_API_PREFIX}elevate-hispano-ticket.mp4`,
};

const REWARD_IMAGE_KEYWORDS = [
  { keywords: ['santoku', '5"'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-santoku-knife-5.jpg` },
  { keywords: ['bamboo', 'bambú', 'bambu', 'cutting board', 'tabla'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-bamboo-cutting-board.jpg` },
  { keywords: ['mixing bowl', 'tazones', 'mezclar', '2-piece', '2 piece', '2 tazones'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-mixing-bowls-2-piece.webp` },
  { keywords: ['sharpener', 'afilador'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-knife-sharpener.jpg` },
  { keywords: ['strainer', 'colador', 'pasta'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-pasta-strainer.jpg` },
  { keywords: ['utensil', 'utensilios'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-utensils-set.jpg` },
  { keywords: ['london', 'vasos'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-london-glasses.jpg` },
  { keywords: ['expertea', 'tetera', 'tea'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-expertea.jpg` },
  { keywords: ['chocolatera', 'chocolate'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-chocolatera.jpg` },
  { keywords: ['smart temp', 'smarttemp'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-smart-temp.webp` },
  { keywords: ['warmer'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-warmer-pro.webp` },
  { keywords: ['utility knife', 'multiuso'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-utility-knife.jpg` },
  { keywords: ['storage', 'recipientes', 'almacenar'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-storage-containers.jpg` },
  { keywords: ['bronze gift'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-santoku-knife-5.jpg` },
  { keywords: ['silver gift'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-bamboo-cutting-board.jpg` },
  { keywords: ['gold gift'], image: `${REWARD_IMAGE_API_PREFIX}royal-prestige-mixing-bowls-2-piece.webp` },
];

export function resolveRewardImageUrl(imageUrl) {
  if (!imageUrl) return null;

  const value = String(imageUrl).trim();
  if (!value) return null;

  if (value.startsWith(REWARD_IMAGE_API_PREFIX)) {
    return value;
  }

  if (value.startsWith('/rewards/')) {
    return `${REWARD_IMAGE_API_PREFIX}${value.slice('/rewards/'.length)}`;
  }

  if (value.startsWith('rewards/')) {
    return `${REWARD_IMAGE_API_PREFIX}${value.slice('rewards/'.length)}`;
  }

  return value;
}

export function getRewardImage(reward) {
  if (!reward) return null;

  const fromApi = resolveRewardImageUrl(reward.image_url);
  if (fromApi) return fromApi;

  const byName = REWARD_IMAGES_BY_NAME[reward.name];
  if (byName) return byName;

  const haystack = `${reward.name || ''} ${reward.description || ''}`.toLowerCase();
  const match = REWARD_IMAGE_KEYWORDS.find(({ keywords }) =>
    keywords.some((kw) => haystack.includes(kw))
  );
  return match?.image ?? null;
}
